import { CombinationKey } from '../../../../services/modules/productDetails/productDetails.types';
import { AvailabilityEnum } from '../../ProductTypes';
import { ProductDetailsDTO } from '../types/productDetails.types';

type CombinationKeyInput = Pick<
  ProductDetailsDTO,
  'productColorId' | 'availability' | 'deliveryWindowId' | 'futureStockDeliveryWindowId'
>;

export const toCombinationKey = (combination: CombinationKeyInput): CombinationKey => {
  const isFutureStock = !!combination.futureStockDeliveryWindowId;
  const availability = isFutureStock ? AvailabilityEnum.FUTURE_STOCK : combination.availability;
  const deliveryWindowId = isFutureStock
    ? combination.futureStockDeliveryWindowId
    : combination.deliveryWindowId;

  return {
    productColorId: combination.productColorId,
    availability,
    deliveryWindowId: deliveryWindowId ?? undefined,
  };
};

export const buildCombinationKey = (combination: CombinationKeyInput): string => {
  const { productColorId, availability, deliveryWindowId } = toCombinationKey(combination);
  return `${productColorId}/${availability}/${deliveryWindowId ?? null}`;
};
